import { useRef, useState } from 'react'
import { Alert, Card, Col, Container, Form, Row } from 'react-bootstrap'
import { Params, useNavigate, useParams } from 'react-router-dom'
import KButton from '../components/KButton'
import {
  getAccessToken,
  getRedirectUrl,
  hideKAlert,
  markAuthenticated,
  setUserAccess,
  submitPinCode,
} from '../helpers'
import { t } from '../locale'
import v from '../validators'

function PinCode() {
  const navigate = useNavigate()

  const params: Readonly<Params<string>> = useParams()

  // The login step hands the pre-auth token over through sessionStorage (the only
  // cross-route channel). Capture it here and pass it to the validation call
  // explicitly; sessionStorage is cleared the moment that call goes out so the
  // global fetch wrapper stops broadcasting it as an `accessToken` header on
  // unrelated requests - a stale pre-auth token on a background call 403s and
  // used to bounce the user back to the login screen.
  const preAuthToken = useRef(getAccessToken() ?? '')

  const [pinCode, setPinCode] = useState(params.pinCode)
  const [isValidPin, setIsValidPin] = useState(true)

  function pinCodeValidation() {
    sessionStorage.removeItem('accessToken')
    submitPinCode(pinCode ?? '', preAuthToken.current).then(r => {
      if (r.userAccess) {
        markAuthenticated()
        setUserAccess(r.userAccess)
        hideKAlert()
        navigate(getRedirectUrl())
      }
    })
  }

  function handlePin(e: any) {
    setPinCode(e.target.value.trimStart())
    setIsValidPin(v.pinCode(pinCode as string))
  }
  function handleSubmit(e: any) {
    e.preventDefault()

    setIsValidPin(v.pinCode(pinCode as string))

    if (v.pinCode(pinCode as string)) {
      pinCodeValidation()
    }
  }

  return (
    <Container className='overflow-hidden'>
      <Row className='pt-5'>
        <Col md={6} className='col-12 mx-auto'>
          <Card className='shadow-sm'>
            <Card.Header className='fw-bold'>{t('pinCodeValidationLogin')}</Card.Header>

            <Card.Body>
              <Alert variant='info'>{t('pinCodeSentMail')}</Alert>

              <Form className='needs-validation' onSubmit={handleSubmit} noValidate>
                <Form.Control
                  id='pinCode'
                  type='text'
                  placeholder={t('pinCode')}
                  isInvalid={!isValidPin}
                  value={pinCode}
                  onChange={handlePin}
                  onKeyUp={handlePin}
                  autoComplete='off'
                  autoFocus
                  required
                  className='mb-3'
                />

                <KButton
                  id='btn-send-pin'
                  type='submit'
                  variant='outline-primary'
                  label={t('confirm')}
                  onSubmit={handleSubmit}
                />
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default PinCode
